// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2"; // import sweetalert2
// import "./CreditDetails.css";
// import { Api } from "../Api/Api";

// export const CreditDetails = () => {
//   const [orders, setOrders] = useState([]);
//   const [searchTerm, setSearchTerm] = useState(""); // search input state

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   // Fetch orders from PHP backend
//   const fetchOrders = async () => {
//     try {
//       const res = await axios.get(`${Api}retail/retail_get2.php`);

//       // Only credit orders
//       const creditOrders = res.data.filter(
//         (order) =>
//           order.payment_type &&
//           order.payment_type.toLowerCase().trim() === "credit"
//       );

//       setOrders(creditOrders);
//     } catch (err) {
//       console.error("Error fetching retail orders:", err);
//     }
//   };

//   // Mark payment as cleared (updates DB and removes from frontend)
//   const handlePaymentCleared = async (id) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "Do you really want to mark this payment as cleared?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, clear it!",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           await axios.post(`${Api}retail/retail_clear.php`, {
//             id,
//           });

//           setOrders((prevOrders) =>
//             prevOrders.filter((order) => order.id !== id)
//           );

//           Swal.fire("Cleared!", "The payment has been cleared.", "success");
//         } catch (err) {
//           console.error("Error clearing payment:", err);
//           Swal.fire("Error!", "Failed to clear payment.", "error");
//         }
//       }
//     });
//   };

//   // Filter orders by searchTerm (mobile number or invoice number)
//   const filteredOrders = orders
//     .filter((order) => {
//       if (!searchTerm) return true;
//       const search = searchTerm.toLowerCase();
//       return (
//         order.customer_mobile?.toLowerCase().includes(search) ||
//         order.invoice_no?.toLowerCase().includes(search)
//       );
//     })
//     // sort so that matches come first
//     .sort((a, b) => {
//       const aMatch =
//         a.customer_mobile?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         a.invoice_no?.toLowerCase().includes(searchTerm.toLowerCase());
//       const bMatch =
//         b.customer_mobile?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         b.invoice_no?.toLowerCase().includes(searchTerm.toLowerCase());
//       return aMatch === bMatch ? 0 : aMatch ? -1 : 1;
//     });

//   return (
//     <div className="credit-container">
//       <h2>Credit Orders</h2>

//       {/* Search box */}
//       <input
//         type="text"
//         placeholder="Search by Mobile or Invoice No"
//         className="search-box"
//         value={searchTerm}
//         onChange={(e) => setSearchTerm(e.target.value)}
//       />

//       {filteredOrders.length === 0 ? (
//         <p>No credit orders found.</p>
//       ) : (
//         <table className="main-table">
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Invoice No</th>
//               <th>Biller Name</th>
//               <th>Customer Name</th>
//               <th>Mobile</th>
//               <th>Address</th>
//               <th>Cart Items</th>
//               <th>Subtotal</th>
//               <th>Discount</th>
//               <th>Total</th>
//               <th>Paid</th>
//               <th>Balance</th>
//               <th>Action</th> {/* Payment cleared button */}
//             </tr>
//           </thead>
//           <tbody>
//             {filteredOrders.map((order, index) => (
//               <tr key={order.id}>
//                 <td>{index + 1}</td>
//                 <td>{order.invoice_no}</td>
//                 <td>{order.billername}</td>
//                 <td>{order.customer_name}</td>
//                 <td>{order.customer_mobile}</td>
//                 <td>{order.customer_address}</td>
//                 <td>
//                   <table className="nested-table">
//                     <thead>
//                       <tr>
//                         <th>Item Name</th>
//                         <th>Quantity</th>
//                         <th>Price</th>
//                         <th>Total</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {order.cart.map((item) => (
//                         <tr key={item.product_id}>
//                           <td>{item.product_name}</td>
//                           <td>{item.quantity}</td>
//                           <td>₹{item.price}</td>
//                           <td>₹{item.quantity * item.price}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </td>
//                 <td>₹{order.subtotal}</td>
//                 <td>₹{order.discount}</td>
//                 <td>₹{order.total}</td>
//                 <td>₹{order.paid_amount}</td>
//                 <td>₹{order.balance}</td>
//                 <td>
//                   <button
//                     className="clear-btn"
//                     onClick={() => handlePaymentCleared(order.id)}
//                   >
//                     Payment Cleared
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./CreditDetails.css";
import { Api } from "../Api/Api";

export const CreditDetails = () => {
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editPaidAmount, setEditPaidAmount] = useState("");

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await axios.get(`${Api}retail/retail_get2.php`);
      const creditOrders = res.data.filter(
        (order) =>
          order.payment_type &&
          order.payment_type.toLowerCase().trim() === "credit"
      );
      setOrders(creditOrders);
    } catch (err) {
      console.error("Error fetching retail orders:", err);
    }
  };

  const handlePaymentCleared = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to mark this payment as cleared?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, clear it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.post(`${Api}retail/retail_clear.php`, { id });

          if (res.data.status === "success") {
            setOrders((prevOrders) =>
              prevOrders.map((order) =>
                order.id === id
                  ? {
                      ...order,
                      paid_amount: res.data.paid_amount,
                      balance: res.data.balance,
                    }
                  : order
              )
            );

            Swal.fire("Cleared!", "The payment has been cleared.", "success");
          } else {
            Swal.fire("Error!", res.data.message, "error");
          }
        } catch (err) {
          console.error("Error clearing payment:", err);
          Swal.fire("Error!", "Failed to clear payment.", "error");
        }
      }
    });
  };

  const handleSaveEdit = async (order) => {
    try {
      const res = await axios.post(`${Api}retail/retail_update2.php`, {
        id: order.id,
        paid_amount: editPaidAmount,
      });

      if (res.data.status === "success") {
        setOrders((prevOrders) =>
          prevOrders.map((o) =>
            o.id === order.id
              ? {
                  ...o,
                  paid_amount: res.data.paid_amount,
                  balance: res.data.balance,
                }
              : o
          )
        );
        Swal.fire("Updated!", "Paid amount updated successfully.", "success");
        setEditingId(null);
      } else {
        Swal.fire("Error!", res.data.message, "error");
      }
    } catch (err) {
      console.error("Error updating payment:", err);
      Swal.fire("Error!", "Failed to update payment.", "error");
    }
  };

  const filteredOrders = orders
    .filter((order) => {
      if (!searchTerm) return true;
      const search = searchTerm.toLowerCase();
      return (
        order.customer_mobile?.toLowerCase().includes(search) ||
        order.invoice_no?.toLowerCase().includes(search)
      );
    })
    .sort((a, b) => {
      const aMatch =
        a.customer_mobile?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        a.invoice_no?.toLowerCase().includes(searchTerm.toLowerCase());
      const bMatch =
        b.customer_mobile?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        b.invoice_no?.toLowerCase().includes(searchTerm.toLowerCase());
      return aMatch === bMatch ? 0 : aMatch ? -1 : 1;
    });

  return (
    <div className="credit-container">
      <h2>Credit Orders</h2>
      <input
        type="text"
        placeholder="Search by Mobile or Invoice No"
        className="search-box"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {filteredOrders.length === 0 ? (
        <p>No credit orders found.</p>
      ) : (
        <table className="main-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Invoice No</th>
              <th>Biller Name</th>
              <th>Customer Name</th>
              <th>Mobile</th>
              <th>Address</th>
              <th>Cart Items</th>
              <th>Subtotal</th>
              {/* <th>Discount</th> */}
              <th>Total</th>
              <th>Paid</th>
              <th>Balance</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.map((order, index) => (
              <tr key={order.id}>
                <td>{index + 1}</td>
                <td>{order.invoice_no}</td>
                <td>{order.billername}</td>
                <td>{order.customer_name}</td>
                <td>{order.customer_mobile}</td>
                <td>{order.customer_address}</td>
                <td>
                  <table className="nested-table">
                    <thead>
                      <tr>
                        <th>Item Name</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {order.cart.map((item) => (
                        <tr key={item.product_id}>
                          <td>{item.product_name}</td>
                          <td>{item.quantity}</td>
                          <td>₹{item.price}</td>
                          <td>₹{item.quantity * item.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </td>
                <td>₹{order.subtotal}</td>
                {/* <td>₹{order.discount}</td> */}
                <td>₹{order.total}</td>
                <td>
                  {editingId === order.id ? (
                    <input
                      type="number"
                      value={editPaidAmount}
                      onChange={(e) => setEditPaidAmount(e.target.value)}
                    />
                  ) : (
                    `₹${order.paid_amount}`
                  )}
                </td>
                <td>₹{order.balance}</td>

                <td>
                  {editingId === order.id ? (
                    <div className="action-buttons">
                      <button
                        className="save-btn"
                        onClick={() => handleSaveEdit(order)}
                      >
                        Save
                      </button>
                      <button
                        className="cancel-btn"
                        onClick={() => setEditingId(null)}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div className="action-buttons">
                      <button
                        className="edit-btn"
                        onClick={() => {
                          setEditingId(order.id);
                          setEditPaidAmount(order.paid_amount);
                        }}
                      >
                        Edit
                      </button>
                      <button
                        className="clear-btn"
                        onClick={() => handlePaymentCleared(order.id)}
                      >
                        Payment Cleared
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
